import { fill } from './fill.js';
import { DemoReportCardProgressGr78202307 as Page } from './Page.jsx';
import templateUrl from './template.pdf';

export default {
  key:         'pgrc7to8_2023_07',
  label:       'Progress Report - Gr. 7-8',
  templateUrl,
  fill,
  Page,
};
